/*
 *
 * ChatbotWrapper
 *
 * @version 1.0.0
 * @author Marco Alessandroni
 * @since 12-May-2025
*/

import ChatbotWrapper from './ChatbotWrapperContainer'

export default ChatbotWrapper
